import { render, staticRenderFns } from "./InfoPanel.vue?vue&type=template&id=766b4277&scoped=true&"
import script from "./InfoPanel.vue?vue&type=script&setup=true&lang=ts&"
export * from "./InfoPanel.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./InfoPanel.vue?vue&type=style&index=0&id=766b4277&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766b4277",
  null
  
)

export default component.exports